import { createClient } from "@supabase/supabase-js";

// In CRA, env vars must start with REACT_APP_
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    "Supabase URL or Anon Key is missing. Check your .env file."
  );
}

// standard createClient
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;